<template>
<div>
    <!-- page wrapper start -->
    <div class="pg-wrapper">
      <app-header>
        <div class="title-bar" slot="header-foot">
          <button @click="goBack()" class="button is-flex nav-back">
            <img src="@/assets/img/icon-nav-arrow-left.svg" alt="Go Back">
          </button>
          <h1 class="title">{{ verified ? 'Email Verified' : 'Verify Email'}} </h1>
        </div>
      </app-header>
     <main class="content-wrapper mt-5">
        <div class="container">
          <div class="inner-wrapper has-text-centered">
            <template v-if="verified">
               <img src="@/assets/img/icon-email.svg" alt="email" class="mb20">
              <h3 class="title is-size-15 sf-pro-text-bold mb20">Email Successfully Verified</h3>
              <p class="is-size-15 mb50">Thanks for signing up! You can now start browsing Budler.</p>
              <router-link class="button is-large is-primary is-full-width" :to="{ name: 'HomePage', query: $route.query}">Start Browsing</router-link>
            </template>
            <loading v-else></loading>
          </div>
        </div>
      </main>
      <app-footer></app-footer>
    </div>
  </div>
</template>

<script>
import NormalApis from '@/Components/Controllers/NormalApis';
import Env from "@/env";
export default {
  data() {
    return {
      verified: false,
    };
  },
  
  mounted() {
    if(this.$route.query.token){
      this.verifyEmail(this.$route.query.token);
    } else {
      this.$router.push({ name: 'HomePage'})
    }
  },

  methods: {
    verifyEmail(token) {
      const url = `${Env.loginUrl}/api/v1/verifications/?token=${token}`;
        NormalApis.getApi(
          url,
          {
            "app-id": Env.loginAppId,
            "app-secret": Env.loginAppSecret
          }
        )
        .then( response => {
          this.verified = true;    
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
};
</script>
<style scoped>
.mt-5{
  margin-top:50px;
}
</style>